

// src/components/ReviewBooking.jsx
import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import AddressInputs from "./AddressInputs";
import {
  Box,
  Paper,
  Typography,
  Button,
  Chip,
  Avatar,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@mui/lab";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { format } from "date-fns";
import { useBookingState, useBookingDispatch } from "./BookingContext";
import { getFareEstimate, createBooking } from "./bookingApi";

import "./ReviewBooking.css";

export default function ReviewBooking() {
  const {
    rideType,
    terminal,
    pickup,
    dropOff,
    dateTime,
    returnDateTime,
    departureDateTime,
    rentalPackage,
    mode,
    name,
    phone,
    email,
    when,
    pickupCoordinates,
    dropOffCoordinates,
    airportDirection,
    fareEstimate,
  } = useBookingState();
   const [editingField, setEditingField] = useState(null);

  // helper to show pickup first, then dropOff
  const startEdit = () => {
    console.log("----------------------")
    setEditingField("pickup");
  };

  const onFieldSelect = (field, placeName, coords) => {
    if (field === "pickup") {
      dispatch({ type: "SET_PICKUP", payload: { placeName, coords } });
    } else {
      dispatch({ type: "SET_DROPOFF", payload: { placeName, coords } });
    }

    // if this trip needs both and we're coming from pickup → go to dropOff
    const needsBoth = rideType !== "rental";
    if (needsBoth && field === "pickup") {
      setEditingField("dropOff");
      return;
    }
    // otherwise we’re done editing
    setEditingField(null);
  };
  const dispatch = useBookingDispatch();
  const rideLabel = rideType.charAt(0).toUpperCase() + rideType.slice(1);
  const { posterId } = useBookingState();
  const passenger = {
    name,
    avatarUrl: "https://avatar.iran.liara.run/public/13",
  };
  const [isBooking, setIsBooking] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  console.log("selectedPackage", rentalPackage);
  useEffect(() => {
    const isDropRequired = rideType !== "rental";
    console.log(isDropRequired);
    console.log(posterId);
    console.log(pickup);
    if (!posterId || !pickup || (isDropRequired && !dropOff)) return;

    const fetchEstimate = async () => {
      const requestBody = {
        posterId,
        bookingType: rideType,
        airportDirection: rideType === "airport" ? airportDirection : undefined,
        pickupLocation: pickup,
        dropOffLocation: dropOff,
        pickupCoordinates: pickupCoordinates || [0, 0],
        dropOffCoordinates: dropOffCoordinates || [0, 0],
        pickupDateTime: dateTime,
        departureDateTime: departureDateTime || dateTime,
        arrivalDateTime: returnDateTime || null,
        rentalPackage: rentalPackage || "",
        rideOption: when === "now" ? "rideNow" : "rideLater",
        tripType:
          rideType === "outstation"
            ? mode === "drop"
              ? "round-trip"
              : "oneWay"
            : "",
        name,
        phoneNumber: phone,
        email,
      };

      console.log("fareEstimateReqbody-----", requestBody);

      const response = await getFareEstimate(requestBody);
      console.log(response);
      if (response.success) {
        dispatch({ type: "SET_FARE_ESTIMATE", payload: response.result });
      } else {
        console.error("Fare estimate failed:", response.message);
      }
    };

    fetchEstimate();
  }, [posterId, pickup, dropOff, dateTime]);

  let distance = "—";

  if (rideType === "rental" && rentalPackage) {
    // Extract distance from rental package label (e.g., "4 hrs / 40 kms")
    const match = rentalPackage.match(/(\d+\s*kms)/i);

    distance = match ? match[1] : "—";
  } else if (fareEstimate?.breakdown?.[0]?.distance) {
    distance = `${Math.ceil(fareEstimate.breakdown[0].distance)} kms`;
  }

  const handleCreateBooking = async () => {
    console.log("clicked on button");
    setIsBooking(true);
    const requestBody = {
      posterId,
      bookingType: rideType,
      airportDirection: rideType === "airport" ? airportDirection : undefined,
      pickupLocation: pickup,
      dropOffLocation: dropOff,
      pickupCoordinates: pickupCoordinates || [0, 0],
      dropOffCoordinates: dropOffCoordinates || [0, 0],
      pickupDateTime: dateTime,
      departureDateTime: departureDateTime || dateTime,
      arrivalDateTime: returnDateTime || null,
      rentalPackage: rentalPackage || "",
      rideOption: when === "now" ? "rideNow" : "rideLater",
      tripType:
        rideType === "outstation"
          ? mode === "drop"
            ? "round-trip"
            : "oneWay"
          : "",
      name,
      phoneNumber: phone,
      email,
      fareEstimate, // ✅ Include the entire fareEstimate object
    };

    const result = await createBooking(requestBody);
    setIsBooking(false);
    if (result.success) {
      console.log("✅ Booking created");
      dispatch({ type: "TO_CONFIRMATION" });
      // dispatch or navigate to confirmation screen
    } else {
      setSnackbar({
        open: true,
        message: result.message || "Booking failed.",
        severity: "error",
      });
      console.error("❌ Booking failed:", result.message);
      // show error to user
    }
  };

  return (
    <Box className="review-wrapper" sx={{ position: 'relative' }}>

 {/* Address‐search overlay */}
      <AnimatePresence>
        {editingField && (
          <motion.div
            key="address-edit"
            initial={{ y: 300, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 300, opacity: 0 }}
            transition={{ duration: 0.3 }}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              zIndex: 10,
            }}
          >
            <AddressInputs
              rideType={rideType}
              mode={mode}
              terminal={terminal}
              pickup={pickup}
              dropOff={dropOff}
              editingField={editingField}
              onRowClick={(f) => setEditingField(f)}            // for manual switches
              onFieldSelect={onFieldSelect}                      // when a place is tapped
             onPickupChange={(placeName, coords = [0,0]) => {
    dispatch({
      type: 'SET_PICKUP',
      payload: { placeName, coords }
    });
  }}
  onDropOffChange={(placeName, coords = [0,0]) => {
    dispatch({
      type: 'SET_DROPOFF',
      payload: { placeName, coords }
    });
  }}
  onCancel={() => setEditingField(null)}
            />
          </motion.div>
        )}
      </AnimatePresence>

<AnimatePresence>
      {!editingField && (
        <motion.div
          key="review-layout"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <Typography className="review-title" align="center" gutterBottom>
        Review your booking
      </Typography>
      <Paper className="review-paper address-card" elevation={1}>
        <Box className="address-header">
  <Button 
    size="small" 
    className="review-edit-btn"
   onClick={startEdit}
  >
    EDIT
  </Button>
</Box>
        <Timeline className="address-timeline">
          <TimelineItem className="zero-padding">
            <TimelineSeparator className="zero-padding">
              <TimelineDot className="pickup-dot">
               <img
    src="/icons/pickup.png"
    alt="Pickup"
    style={{ display: "block" }}
  />
                </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Chip label="Pick-up" className="pickup-chip" size="small" />
              <Typography className="address-text">{pickup}</Typography>
            </TimelineContent>
          </TimelineItem>

          {/* <TimelineItem>
            <TimelineSeparator>
              <TimelineDot className="dropoff-dot" />
            </TimelineSeparator>
            <TimelineContent>
              <Chip label="Drop-off" className="dropoff-chip" size="small" />
              <Typography className="address-text">{dropOff}</Typography>
            </TimelineContent>
          </TimelineItem> */}

          {rideType === "rental" ? (
            <TimelineItem className="zero-padding">
              <TimelineSeparator>
                <TimelineDot className="dropoff-dot" >
                   <img
    src="/icons/dropoff.png"
    alt="Drop-off"
    style={{  display: "block" }}
  />
                 </TimelineDot>
              </TimelineSeparator>
              <TimelineContent>
                <Chip label="Package" className="dropoff-chip" size="small" />
                <Typography className="address-text">
                  {rentalPackage}
                </Typography>
              </TimelineContent>
            </TimelineItem>
          ) : (
            <TimelineItem className="zero-padding">
              <TimelineSeparator>
                <TimelineDot className="dropoff-dot">
                   <img
    src="/icons/dropoff.png"
    alt="Drop-off"
    style={{  display: "block" }}
  />
                 </TimelineDot>
              </TimelineSeparator>
              <TimelineContent>
                <Chip label="Drop-off" className="dropoff-chip" size="small" />
                <Typography className="address-text">{dropOff}</Typography>
              </TimelineContent>
            </TimelineItem>
          )}
        </Timeline>

        <Box
          className="type-distance-section"
          display="flex"
          alignItems="center"
        >
          <Chip label={rideLabel} className="ride-type-chip" size="small" />
          <Box display="flex" alignItems="center" sx={{ ml: "auto" }}>
            <Typography className="distance-label">Distance:&nbsp;</Typography>
            <LocationOnIcon
              fontSize="small"
              sx={{ color: "#5BBB9A", width: 16, height: 16 }}
            />

            {/* <Typography variant="body1" fontWeight={500} sx={{ ml: 0.5, mt: 0.5 }}>
              {distance}
            </Typography> */}
            <Typography className="distance-value">{distance}</Typography>
          </Box>
        </Box>
      </Paper>

      <Paper className="review-paper datetime-card" elevation={1}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center">
            {/* <CalendarTodayIcon sx={{ mr: 1 }} /> */}
             <img
    src="/icons/date_image.png"
    alt="calendar"
    class="img-width"
    style={{ display: "block" }}
   
  />
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "14px",
                lineHeight: "17px",
                color: "#000000",
                ml:1
              }}
            >
              {format(dateTime, "dd MMM yyyy 'at' hh:mm a")}
            </Typography>
          </Box>
          {/* <Button size="small" onClick={() => dispatch({ type: 'EDIT_STEP', payload: 'details' })}>
            Edit
          </Button> */}
        </Box>
      </Paper>

      {rideType === "outstation" && mode === "drop" && returnDateTime && (
        <Paper className="review-paper datetime-card" elevation={1}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box display="flex" alignItems="center">
              {/* <CalendarTodayIcon sx={{ mr: 1 }} /> */}
               <img
    src="/icons/date_image.png"
    alt="calendar"
    style={{ display: "block" }}
   
  />
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "14px",
                  lineHeight: "17px",
                  color: "#000000",
                   ml:1
                }}
              >
                {format(returnDateTime, "dd MMM yyyy 'at' hh:mm a")}
              </Typography>
            </Box>
            {/* <Button size="small" onClick={() => dispatch({ type: 'EDIT_STEP', payload: 'details' })}>
             Edit
           </Button> */}
          </Box>
        </Paper>
      )}

      <Paper className="review-paper passenger-card" elevation={1}>
        <Typography
          sx={{
            fontFamily: "Lato",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "12px",
            color: "#000000",
            opacity: 0.6,
          }}
        >
          Passenger details
        </Typography>

        <Box display="flex" alignItems="center" mt={1}>
          <Avatar src={passenger.avatarUrl} />
          <Typography
            sx={{
              ml: 2,
              fontFamily: "Lato",
              fontStyle: "normal",
              fontWeight: 700,
              fontSize: "12px",
              lineHeight: "17px",
              color: "#000000",
            }}
          >
            {passenger.name}
          </Typography>
        </Box>
      </Paper>

      {/* <Paper className="review-paper fare-card" elevation={1}>
        <Box className="fare-row">
          <Typography>Trip amount</Typography>
          <Typography>₹{fare.amount}</Typography>
        </Box>
        <Box className="fare-row">
          <Typography>GST (7.5%)</Typography>
          <Typography>₹{fare.gst}</Typography>
        </Box>
        <Box className="fare-row total-row">
          <Typography>Total</Typography>
          <Typography>₹{fare.total}</Typography>
        </Box>

        <Box sx={{ mt: 2, mb: 2, mx: 2 }}>
          <Typography sx={{ textAlign: 'center', fontSize: '10px' }}>
            The fare estimate excludes night bata, toll, permit, and parking charges.
            These additional charges must be paid separately to the driver.
          </Typography>
        </Box>
      </Paper> */}

      {fareEstimate && (
        <Paper className="review-paper fare-card" elevation={1}>
          {/* <Typography  sx={{
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '12px',
    color: '#000000',
    opacity: 0.6,
  }}>Fare Estimate</Typography> */}
          <Box display="flex" justifyContent="space-between" mt={1}>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "14px",
                color: "#000000",
                opacity: 0.6,
              }}
            >
              Base fare
            </Typography>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "12px",
                lineHeight: "14px",
                color: "#000000",
              }}
            >
              ₹ {fareEstimate?.breakdown?.[0]?.calculatedFare}
            </Typography>
          </Box>
          {rideType === "airport" && (
            <Box display="flex" justifyContent="space-between" mt={1}>
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "14px",
                  color: "#000000",
                  opacity: 0.6,
                }}
              >
                Toll
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "12px",
                  lineHeight: "14px",
                  color: "#000000",
                }}
              >
                ₹ {fareEstimate?.breakdown?.[0]?.toll}
              </Typography>
            </Box>
          )}
          {rideType === "outstation" && (
            <Box display="flex" justifyContent="space-between" mt={1}>
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "14px",
                  color: "#000000",
                  opacity: 0.6,
                }}
              >
                Day bata
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "12px",
                  lineHeight: "14px",
                  color: "#000000",
                }}
              >
                ₹ {fareEstimate?.breakdown?.[0]?.applicableBata}
              </Typography>
            </Box>
          )}
          <Box display="flex" justifyContent="space-between" mt={1}>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "14px",
                color: "#000000",
                opacity: 0.6,
              }}
            >
              Convenience fee
            </Typography>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "12px",
                lineHeight: "14px",
                color: "#000000",
              }}
            >
              ₹ {fareEstimate?.breakdown?.[0]?.convenienceFee}
            </Typography>
          </Box>
          {/* <Box display="flex" justifyContent="space-between" mt={1}>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "14px",
                color: "#000000",
                opacity: 0.6,
              }}
            >
              GST(5%)
            </Typography>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "12px",
                lineHeight: "14px",
                color: "#000000",
              }}
            >
              ₹ {fareEstimate?.breakdown?.[0]?.gst}
            </Typography>
          </Box> */}
          <Box display="flex" justifyContent="space-between" mt={1}>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "14px",
                color: "#000000",
                opacity: 0.6,
              }}
            >
              Total
            </Typography>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "12px",
                lineHeight: "14px",
                color: "#000000",
              }}
            >
              ₹ {fareEstimate?.totalFare}
            </Typography>
          </Box>
          {rideType === "outstation" && (
            <Box sx={{ mt: 2, mx: 2 }}>
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "10px",
                  lineHeight: "12px",
                  color: "#000000",
                  opacity: 0.6,
                  textAlign: "center",
                }}
              >
                The fare estimate excludes night bata, toll, permit, and parking
                charges. These additional charges must be paid separately to the
                driver.
              </Typography>
            </Box>
          )}
          {rideType === "rental" && (
            <Box sx={{ mt: 2, mx: 2 }}>
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "10px",
                  lineHeight: "12px",
                  color: "#000000",
                  opacity: 0.6,
                  textAlign: "center",
                }}
              >
                The fare estimate excludes toll, and parking charges. These
                additional charges must be paid separately to the driver.
              </Typography>
            </Box>
          )}
        </Paper>
      )}

      <Button
        fullWidth
        onClick={handleCreateBooking}
        disabled={false}
        sx={{
          mt: 2,
          height: "56px", 
          backgroundColor: "#A1F0D7",
          color: "#000000", // from font color in spec
          textTransform: "none", // use normal case instead of uppercase
          fontFamily: "Lato",
          fontStyle: "normal",
          fontWeight: 700,
          fontSize: "14px",
          lineHeight: "17px",
          borderRadius: "36px",
          // py: 1.5,
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "#94D9C1",
            boxShadow: "none",
          },
        }}
      >
        {isBooking ? (
          <CircularProgress size={20} sx={{ color: "#0C1B1F" }} />
        ) : (
          "CONFIRM BOOKING"
        )}
      </Button>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
      />
          </motion.div>
      )};
      </AnimatePresence>
      
    </Box>
 
  );
  
}
